import { useRequestData } from 'utils/hooks/request';
import ManagedLayout from 'layoutManagement/ManagedLayout';
import { getAllSharesAction } from 'layoutManagement/store/thunks';
import { WidgetType } from 'widgets/WidgetType';
import { useEffect } from 'react';

export function useWidgetLayouts(widgetType?: WidgetType): ManagedLayout[] {
    const { request, data: layouts } = useRequestData<
        [string],
        ManagedLayout[]
    >(getAllSharesAction, []);

    useEffect(() => {
        if (widgetType) {
            request(widgetType);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [widgetType]);

    return layouts;
}
